<template>
    <div class="account-name-container">
        <Avatar v-if="!validating" :color="domainColor" :platform="platform" showAccountType>
            {{ initials }}
        </Avatar>
        <Skeleton v-else-if="validating" width="36px" height="36px" />
        <Spacer width="1.125rem" />
        <span v-if="!validating" class="impact-stats-table-domain-name">{{ domainName }}</span>
        <div v-else-if="validating" class="impact-stats-table-domain-name-validating">
            <Skeleton width="7rem" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { Avatar, Spacer } from '@opteo/components-next'
import Skeleton from '@/components/util/Skeleton.vue'

const props = defineProps({
    domainName: {
        type: String,
        required: true,
    },
    domainColor: {
        type: String,
        required: false, // Avatar has built-in functionality for a default colour
    },
    platform: {
        type: Number,
        required: true,
    },
    initials: {
        type: String,
        required: true,
    },
    validating: {
        type: Boolean,
        default: false,
    },
})
</script>
<style scoped lang="scss">
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.account-name-container {
    @include flex;
    @include items-center;
    @include ml-24;
}

.impact-stats-table-domain-name {
    @include f-7;
    @include fw-500;
    @include no-wrap;
    color: v-bind(domainColor);
    line-height: 4.625rem;
    height: 4.625rem;
    @include no-select;
    max-width: 20rem;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
}
.impact-stats-table-domain-name-validating {
    height: 4.625rem;
    @include flex;
    @include items-center;
}
</style>
